//src/admin/pages/AdminAddOrders.js
import React, { useEffect, useState, useContext, useMemo, useRef } from "react";
import { useNavigate } from "react-router-dom";
import AdminSidebar from "../AdminSidebar";
import AdminHeader from "../AdminHeader";
import { AdminLanguageContext } from "../context/AdminLanguageContext";
import { getAdminProducts } from "../../services/adminProducts.api";
import { createAdminOrder } from "../../services/adminOrders.api";
import { apiRequest } from "../../services/api";
import { getAdminShippingSettings } from "../../services/adminShippingSettings.api";
import { getAdminCustomers } from "../../services/adminCustomers.api";
import {
  getAdminCustomerById,
  updateAdminCustomerAddress
} from "../../services/adminCustomers.api";
import {
  FaSearch,
  FaPen,
  FaTimes,
  FaPlus,
  FaChevronRight,
  FaPlusCircle,
  FaInbox
} from "react-icons/fa";
import { FiChevronRight, FiChevronDown } from "react-icons/fi";
import { FiAlertCircle } from "react-icons/fi";

/* ================= CONSTANTS ================= */
const LEBANON_GOVERNORATES = [
  { EN: "Beirut", AR: "بيروت" },
  { EN: "Mount Lebanon", AR: "جبل لبنان" },
  { EN: "North", AR: "الشمال" },
  { EN: "South", AR: "الجنوب" },
  { EN: "Bekaa", AR: "البقاع" },
  { EN: "Nabatieh", AR: "النبطية" },
  { EN: "Akkar", AR: "عكار" },
  { EN: "Baalbek-Hermel", AR: "بعلبك الهرمل" },
];

function AdminAddOrders() {
  const navigate = useNavigate();
  const { lang } = useContext(AdminLanguageContext);

  const [isOpen, setIsOpen] = useState(false);

  const [products, setProducts] = useState([]);
const [customers, setCustomers] = useState([]);

const [productsLoading, setProductsLoading] = useState(true);
const [customersLoading, setCustomersLoading] = useState(true);
const [customerDetailsLoading, setCustomerDetailsLoading] = useState(false);
const [creatingCustomer, setCreatingCustomer] = useState(false);
const [savingAddress, setSavingAddress] = useState(false);
const [creatingOrder, setCreatingOrder] = useState(false);

  const [items, setItems] = useState([]);

  const [isDirty, setIsDirty] = useState(false);
  const [showLeaveConfirm, setShowLeaveConfirm] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState(null);

  const [activeProduct, setActiveProduct] = useState(null);
  const [activeVariant, setActiveVariant] = useState(null);
  const [variantQty, setVariantQty] = useState(1);

  const [showConfirm, setShowConfirm] = useState(false);

  const [productSearch, setProductSearch] = useState("");
  const [productPickerOpen, setProductPickerOpen] = useState(false);

  const [customerSearch, setCustomerSearch] = useState("");
  const [customerPickerOpen, setCustomerPickerOpen] = useState(false);
  const [createCustomerOpen, setCreateCustomerOpen] = useState(false);

  const [noteOpen, setNoteOpen] = useState(false);
  const [discountModalOpen, setDiscountModalOpen] = useState(false);
  const [discountType, setDiscountType] = useState("percent");
  const [shippingModalOpen, setShippingModalOpen] = useState(false);
  const [extraFeesModalOpen, setExtraFeesModalOpen] = useState(false);

  const [draftNote, setDraftNote] = useState("");

  const [productSearchLoading, setProductSearchLoading] = useState(false);

  const [selectedIndex, setSelectedIndex] = useState(0);

  const [customerMenuOpen, setCustomerMenuOpen] = useState(false);
  const [editAddressOpen, setEditAddressOpen] = useState(false);
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);

  const [customerOrdersCount, setCustomerOrdersCount] = useState(0);

  const customerMenuRef = useRef(null);
  const productPickerRef = useRef(null);
  const customerPickerRef = useRef(null);

  const [productSearchType, setProductSearchType] = useState("all");

  const SkeletonLine = ({ className = "" }) => (
  <div className={`animate-pulse rounded-md bg-[#e4e5e7] ${className}`} />
);

const ProductPickerSkeleton = () => (
  <div className="divide-y divide-[#f1f2f3]">
    {[1, 2, 3, 4, 5].map((n) => (
      <div
        key={n}
        className="grid grid-cols-[1fr_100px_120px] items-center px-6 py-3"
      >
        <div className="flex items-center gap-3">
          <SkeletonLine className="w-10 h-10 rounded-lg" />
          <div className="space-y-2 w-full">
            <SkeletonLine className="h-3 w-40" />
            <SkeletonLine className="h-3 w-24" />
          </div>
        </div>

        <SkeletonLine className="h-3 w-10 mx-auto" />
        <SkeletonLine className="h-3 w-14" />
      </div>
    ))}
  </div>
);

const CustomerPickerSkeleton = () => (
  <div className="divide-y divide-[#f1f2f3]">
    {[1, 2, 3, 4].map((n) => (
      <div key={n} className="px-4 py-3 space-y-2">
        <SkeletonLine className="h-3 w-36" />
        <SkeletonLine className="h-3 w-52" />
      </div>
    ))}
  </div>
);

  /* ================= CUSTOMER ================= */
  const [customer, setCustomer] = useState({
  name: "",
  phone: "",
  email: "",
  country: "Lebanon",
  governorate: "",
    area: "",
    street: "",
    building: "",
    note: "",
  });

 const [newCustomer, setNewCustomer] = useState({
  name: "",
  phone: "",
  email: "",
  country: "Lebanon",
  governorate: "",
    area: "",
    street: "",
    building: "",
    note: "",
  });

  /* ================= ORDER ================= */
  const [order, setOrder] = useState({
    order_source: "website",
    status: "pending",
    payment_method: "cod",
    payment_status: "unpaid",
    shipping_method: "delivery",
    discount_amount: 0,
    shipping_fee: 4,
    extra_fee_label: "",
    extra_fee_amount: 0,
    notes: "",
  });

  const TEXT = {
    EN: {
      editDiscount: "Edit discount",
      addDiscount: "Add discount",
      editShippingAddress: "Edit shipping address",
      removeCustomer: "Remove customer",
      contactInformation: "Contact information",
      shippingAddress: "Shipping address",
      noOrders: "No orders",
      orderCount: "order",
      orderCountPlural: "orders",
      addNote: "Add note",
      done: "Done",
country: "Country",
      noteHelper: "To comment on a draft order or mention a staff member",
      discountTitle: "Discount",
      discountType: "Discount type",
      percentage: "Percentage",
      fixedAmount: "Fixed amount",
      amount: "Amount",
      shippingFeeTitle: "Shipping fee",
      deliveryFee: "Delivery fee",
      extraFeesTitle: "Extra fees",
      exampleInsurance: "Example: Insurance",
      city: "City",
      label: "Label",
      website: "Website",
      whatsapp: "WhatsApp",
      phoneRequired: "Phone is required",
      customerNameRequired: "Customer name is required",
      productRequired: "Add at least one product",
      store: "Store",
      itemCount: "item(s)",
      productsCount: "products",
      product: "Product",
      available: "Available",
      price: "Price",
      back: "Orders",
      title: "Create order",
      products: "Products",
      addproducts: "+ Add Product",
      browse: "Browse",
      addCustom: "Add custom item",
      searchProducts: "Search products",
      selectProducts: "Select products",
      noProducts: "No products found",
      customer: "Customer",
      searchCustomer: "Search customer",
      noCustomers: "No customers found",
      createCustomer: "Create a new customer",
      createCustomerTitle: "Create new customer",
      notes: "Notes",
      noNotes: "No notes",
      payment: "Payment",
      subtotal: "Subtotal",
      discount: "Discount",
      shipping: "Shipping or delivery",
      estimatedTax: "Estimated tax",
      notCalculated: "Not calculated",
      total: "Total",
      source: "Order source",
      shippingMethod: "Shipping method",
      delivery: "Delivery",
      pickup: "Pickup",
      extraFees: "Extra fees",
      extraLabel: "Label",
      cancel: "Cancel",
      items: "items",
      colorSize: "Color / Size",
      save: "Save",
      stockWarning: "This product has",
      unitsInStock: "units in stock",
      createOrder: "Create order",
      confirmOrder: "Confirm order",
      confirm: "Confirm",
      quantity: "Qty",
      stock: "Stock",
      noVariants: "No available variants",
      selectGovernorate: "Select governorate",
      name: "Full name",
      phone: "Phone",
      email: "Email",
      governorate: "Governorate",
      area: "Area",
      street: "Street",
      building: "Building",
      note: "Note",
      optional: "Optional",
      addProductFooter: "Add a product to calculate total and create the order",
      selectedCustomer: "Selected customer",
      searchBy: "Search by",
      all: "All",
      category: "Category",
      productName: "Product name",
      productId: "Product ID",
      addressUpdateError: "Failed to update address",
      customerCreateError: "Failed to create customer",
      color: "Color",
      ok: "OK",
      searchOrCreateCustomer: "Search or create a customer",
    },
    AR: {
      editDiscount: "تعديل الخصم",
      addproducts: "+ اضف منتج",
      phoneRequired: "الهاتف مطلوب",
      customerNameRequired: "اسم العميل مطلوب",
      productRequired: "أضف منتجًا واحدًا على الأقل",
      searchOrCreateCustomer: "ابحث عن عميل أو أنشئ عميلًا",
      addDiscount: "إضافة خصم",
      addressUpdateError: "فشل تحديث العنوان",
      editShippingAddress: "تعديل عنوان الشحن",
      removeCustomer: "إزالة العميل",
      contactInformation: "معلومات التواصل",
country: "الدولة",
      shippingAddress: "عنوان الشحن",
      noOrders: "لا توجد طلبات",
      orderCount: "طلب",
      orderCountPlural: "طلبات",
      addNote: "إضافة ملاحظة",
      done: "تم",
      noteHelper: "لإضافة ملاحظة على الطلب أو ذكر أحد الموظفين",
      discountTitle: "الخصم",
      discountType: "نوع الخصم",
      percentage: "نسبة مئوية",
      fixedAmount: "مبلغ ثابت",
      amount: "القيمة",
      shippingFeeTitle: "رسوم الشحن",
      deliveryFee: "رسوم التوصيل",
      extraFeesTitle: "الرسوم الإضافية",
      exampleInsurance: "مثال: تأمين",
      customerCreateError: "فشل إنشاء العميل",
      city: "المدينة",
      label: "الوصف",
      website: "الموقع الإلكتروني",
      whatsapp: "واتساب",
      store: "المتجر",
      itemCount: "عنصر",
      productsCount: "منتج",
      items: "عنصر",
      colorSize: "اللون / المقاس",
      product: "المنتج",
      available: "المتوفر",
      price: "السعر",
      stockWarning: "هذا المنتج يحتوي على",
      unitsInStock: "وحدة في المخزون",
      back: "الطلبات",
      title: "إنشاء طلب",
      ok: "موافق",
      products: "المنتجات",
      selectProducts: "اختر المنتجات",
      browse: "تصفح",
      addCustom: "إضافة منتج مخصص",
      searchProducts: "ابحث عن المنتجات",
      noProducts: "لا توجد منتجات",
      customer: "العميل",
      searchCustomer: "ابحث عن عميل",
      noCustomers: "لا يوجد عملاء",
      createCustomer: "إنشاء عميل جديد",
      createCustomerTitle: "إنشاء عميل جديد",
      notes: "ملاحظات",
      noNotes: "لا توجد ملاحظات",
      payment: "الدفع",
      subtotal: "المجموع الفرعي",
      discount: "الخصم",
      shipping: "الشحن أو التوصيل",
      estimatedTax: "الضريبة التقديرية",
      notCalculated: "غير محسوبة",
      total: "الإجمالي",
      source: "مصدر الطلب",
      shippingMethod: "طريقة الشحن",
      delivery: "توصيل",
      pickup: "استلام",
      extraFees: "رسوم إضافية",
      extraLabel: "الوصف",
      cancel: "إلغاء",
      save: "حفظ",
      createOrder: "إنشاء الطلب",
      confirmOrder: "تأكيد الطلب",
      confirm: "تأكيد",
      quantity: "الكمية",
      stock: "المخزون",
      noVariants: "لا توجد خيارات متاحة",
      selectGovernorate: "اختر المحافظة",
      name: "الاسم الكامل",
      phone: "الهاتف",
      email: "البريد الإلكتروني",
      governorate: "المحافظة",
      area: "المنطقة",
      street: "الشارع",
      building: "المبنى",
      note: "ملاحظة",
      optional: "اختياري",
      addProductFooter: "أضف منتجًا لحساب الإجمالي وإنشاء الطلب",
      selectedCustomer: "العميل المختار",
      searchBy: "البحث حسب",
      all: "الكل",
      category: "التصنيف",
      productName: "اسم المنتج",
      productId: "معرّف المنتج",
      color: "اللون",
    },
  }[lang];

  const availableVariants = useMemo(() => {
    if (!activeProduct) return [];

    const map = new Map();

    activeProduct.variants.forEach((v) => {
      if (v.stock_qty > 0 && !map.has(v.id)) {
        map.set(v.id, v);
      }
    });

    return Array.from(map.values());
  }, [activeProduct]);

  useEffect(() => {
  if (
    items.length > 0 ||
    customer.name ||
    customer.phone ||
    order.notes ||
    order.discount_amount ||
    order.extra_fee_amount
  ) {
    setIsDirty(true);
  }
}, [items, customer, order]);

  useEffect(() => {
  const handleClickOutside = (e) => {
    if (
      customerMenuRef.current &&
      !customerMenuRef.current.contains(e.target)
    ) {
      setCustomerMenuOpen(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);
  return () =>
    document.removeEventListener("mousedown", handleClickOutside);
}, []);

  /* ================= LOAD DATA ================= */
  useEffect(() => {
  setProductsLoading(true);
  setCustomersLoading(true);

  getAdminProducts()
    .then(setProducts)
    .catch(() => setProducts([]))
    .finally(() => setProductsLoading(false));

  getAdminCustomers()
    .then(setCustomers)
    .catch(() => setCustomers([]))
    .finally(() => setCustomersLoading(false));

  getAdminShippingSettings()
    .then((s) => {
      setOrder((prev) => ({
        ...prev,
        shipping_fee: Number(s.default_fee ?? 4),
      }));
    })
    .catch(() => {});
}, []);

  useEffect(() => {
  const beforeUnload = (e) => {
    if (!isDirty) return;
    e.preventDefault();
    e.returnValue = "";
  };

  window.addEventListener("beforeunload", beforeUnload);
  return () => window.removeEventListener("beforeunload", beforeUnload);
}, [isDirty]);

  /* ================= CLOSE PICKERS ================= */
  useEffect(() => {
    const handler = (e) => {
      if (
        productPickerRef.current &&
        !productPickerRef.current.contains(e.target)
      ) {
        setProductPickerOpen(false);
      }

      if (
        customerPickerRef.current &&
        !customerPickerRef.current.contains(e.target)
      ) {
        setCustomerPickerOpen(false);
      }
    };

    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  /* ================= CALCULATIONS ================= */
  const subtotal = useMemo(
    () => items.reduce((s, i) => s + i.unit_price * i.quantity, 0),
    [items]
  );

  const totalItems = useMemo(
    () => items.reduce((s, i) => s + i.quantity, 0),
    [items]
  );

  const discountAmount = Number(order.discount_amount || 0);

  const discountValue =
    discountType === "percent"
      ? subtotal * (discountAmount / 100)
      : discountAmount;

  const shippingFee = Number(order.shipping_fee || 0);
  const extraFeeAmount = Number(order.extra_fee_amount || 0);
  const total = subtotal - discountValue + shippingFee + extraFeeAmount;

  const hasStockIssue = items.some((i) => {
  const product = products.find((p) => p.id === i.product_id);
  const variant = product?.variants?.find((v) => v.id === i.variant_id);
  return i.quantity > (variant?.stock_qty ?? 0);
});

const isOrderInvalid =
  !customer.name ||
  !customer.phone ||
  items.length === 0 ||
  !order.order_source ||
  !order.shipping_method ||
  hasStockIssue;

  /* ================= PHONE FORMAT ================= */
  const formatPhone = (val) => val;

  /* ================= FILTER PRODUCTS ================= */
  const filteredProducts = useMemo(() => {
  const q = productSearch.trim().toLowerCase();

  if (!q) return products.slice(0, 12);

  return products.filter((p) => {
    const productId = (p.public_id || "").toLowerCase();
    const nameEn = (p.name_en || "").toLowerCase();
    const nameAr = (p.name_ar || "").toLowerCase();

    const categories = Array.isArray(p.categories)
      ? p.categories.join(" ").toLowerCase()
      : String(p.categories || "").toLowerCase();

    const colors = Array.isArray(p.variants)
      ? p.variants
          .map((v) => (v.color_name || "").toLowerCase())
          .filter(Boolean)
      : [];

    if (productSearchType === "category") {
      return categories.includes(q);
    }

    if (productSearchType === "product_name") {
      return nameEn.includes(q) || nameAr.includes(q);
    }

    if (productSearchType === "product_id") {
      return productId.includes(q);
    }

    if (productSearchType === "color") {
      return colors.some((color) => color.includes(q));
    }

    return (
      productId.includes(q) ||
      nameEn.includes(q) ||
      nameAr.includes(q) ||
      categories.includes(q) ||
      colors.some((color) => color.includes(q))
    );
  });
}, [products, productSearch, productSearchType]);

  /* ================= FILTER CUSTOMERS ================= */
  const filteredCustomers = useMemo(() => {
    const q = customerSearch.trim().toLowerCase();
    if (!q) return customers.slice(0, 8);

    return customers.filter(
      (c) =>
        (c.name || "").toLowerCase().includes(q) ||
        (c.email || "").toLowerCase().includes(q) ||
        (c.phone || "").toLowerCase().includes(q)
    );
  }, [customers, customerSearch]);

  /* ================= CUSTOMER PICKER ================= */
  const selectCustomer = async (c) => {
  try {
    setCustomerDetailsLoading(true);
    setSelectedCustomerId(c.id);
    setCustomerOrdersCount(c.orders || 0); // ✅ add this line

    const fullCustomer = await getAdminCustomerById(c.id);

    const parts = (fullCustomer.address || "")
      .split("—")
      .map((p) => p.trim());

    setCustomer({
      name: fullCustomer.name || "",
      phone: fullCustomer.phone || "",
      email: fullCustomer.email || "",
country: fullCustomer.addressCountry || "Lebanon",
      governorate: parts[0] || "",
      area: parts[1] || "",
      street: parts[2] || "",
      building: parts[3] || "",
      note: "",
    });

    setCustomerSearch(fullCustomer.name || "");
    setCustomerPickerOpen(false);
    } catch (err) {
    console.error(err);
  } finally {
    setCustomerDetailsLoading(false);
  }
};

  const createCustomerLocally = async () => {
  if (!newCustomer.name || !newCustomer.phone) {
    alert(lang === "EN" ? "Name and phone are required" : "الاسم والهاتف مطلوبان");
    return;
  }

 try {
  setCreatingCustomer(true);
    /* 1️⃣ CREATE CUSTOMER (same as website) */
    const auth = await apiRequest("/auth/guest", {
      method: "POST",
      body: JSON.stringify({
        full_name: newCustomer.name,
        phone: newCustomer.phone,
        email: newCustomer.email || null,
      }),
    });

    /* 2️⃣ UPDATE ADDRESS */
    await apiRequest("/users/me", {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${auth.token}`,
      },
body: JSON.stringify({
  full_name: newCustomer.name,
  phone: newCustomer.phone,
  email: newCustomer.email || null,
  country: newCustomer.country,
  city: newCustomer.governorate,
  area: newCustomer.area,
  street: newCustomer.street,
  building: newCustomer.building,
}),
    });

    /* 3️⃣ UPDATE ADMIN UI */
setCustomer({
  name: newCustomer.name,
  phone: newCustomer.phone,
  email: newCustomer.email,
  country: newCustomer.country,
  governorate: newCustomer.governorate,
  area: newCustomer.area,
  street: newCustomer.street,
  building: newCustomer.building,
  note: newCustomer.note,
});

    setCustomerSearch(newCustomer.name);
    setCustomerOrdersCount(0);

    /* 4️⃣ ADD TO LOCAL LIST (so search works instantly) */
    setCustomers((prev) => [
      {
        id: Date.now(),
        name: newCustomer.name,
        phone: newCustomer.phone,
        email: newCustomer.email,
        orders: 0,
      },
      ...prev,
    ]);

    setCreateCustomerOpen(false);
    setCustomerPickerOpen(false);

    setNewCustomer({
  name: "",
  phone: "",
  email: "",
  country: "Lebanon",
  governorate: "",
  area: "",
  street: "",
  building: "",
  note: "",
});

 } catch (err) {
  console.error(err);
  alert(TEXT.customerCreateError);
} finally {
  setCreatingCustomer(false);
}
};

const saveEditedAddress = async () => {
  if (!selectedCustomerId) {
    setEditAddressOpen(false);
    return;
  }

  try {
  setSavingAddress(true);

await updateAdminCustomerAddress(selectedCustomerId, {
  country: customer.country || "Lebanon",
  city: customer.governorate || null,
      area: customer.area || null,
      street: customer.street || null,
      building: customer.building || null,
    });

    setEditAddressOpen(false);
  } catch (err) {
  console.error(err);
  alert(TEXT.addressUpdateError);
} finally {
  setSavingAddress(false);
}
};

  /* ================= ADD ITEM ================= */
  const confirmAddItem = () => {
    if (!activeProduct || !activeVariant) return;

    const price = activeProduct.on_sale
      ? activeProduct.base_price * (1 - activeProduct.sale_percent / 100)
      : activeProduct.base_price;

    setItems((prev) => [
      ...prev,
      {
        product_id: activeProduct.id,
        variant_id: activeVariant.id,
        name_en: activeProduct.name_en,
        name_ar: activeProduct.name_ar,
        color: activeVariant.color_name,
        size: activeVariant.size,
        unit_price: Number(price),
        quantity: variantQty,
      },
    ]);

    setActiveProduct(null);
setActiveVariant(null);
setVariantQty(1);
setProductSearch("");
setProductSearchType("all");
setProductPickerOpen(false);
  };

  const removeItem = (idx) => {
    setItems(items.filter((_, i) => i !== idx));
  };

  const handleNavigate = (path) => {
  if (!isDirty) {
    navigate(path);
  } else {
    setPendingNavigation(() => () => navigate(path));
    setShowLeaveConfirm(true);
  }
};

const handleBackClick = () => {
  handleNavigate("/admin/orders");
};

  const updateItemQty = (idx, qty) => {
    const value = Number(qty);
    if (value < 1) return;

    setItems((prev) =>
      prev.map((item, i) => (i === idx ? { ...item, quantity: value } : item))
    );
  };

  /* ================= NOTES ================= */
  const saveNote = () => {
    setOrder((prev) => ({ ...prev, notes: draftNote }));
    setNoteOpen(false);
  };

  /* ================= SUBMIT ================= */
  const submit = async () => {
    if (!customer.phone) {
      alert(TEXT.phoneRequired);
      return;
    }

    if (!customer.name) {
      alert(TEXT.customerNameRequired);
      return;
    }

    if (items.length === 0) {
      alert(TEXT.productRequired);
      return;
    }

    setCreatingOrder(true);

const cleanCustomer = {
  name: customer.name,
  phone: customer.phone,
  email: customer.email || null,
  note: customer.note || null,
  country: customer.country || "Lebanon",
  governorate: customer.governorate || null,
      area: customer.area || null,
      street: customer.street || null,
      building: customer.building || null,
    };

    try {
  await createAdminOrder({
    order_source: order.order_source,
    status: order.status,
    payment_method: order.payment_method,
    payment_status: order.payment_status,
    shipping_method: order.shipping_method,
    discount_amount: order.discount_amount,
    discount_type: discountType,
    discount_input: order.discount_amount,
    shipping_fee: order.shipping_fee,
    extra_fee_label: order.extra_fee_label,
    extra_fee_amount: order.extra_fee_amount,
    notes: order.notes,
    customer: cleanCustomer,
    items,
  });

  navigate("/admin/orders");
} catch (err) {
  console.error(err);
} finally {
  setCreatingOrder(false);
}
  };

  useEffect(() => {
  if (!productPickerOpen) return;

  const handler = (e) => {

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setSelectedIndex((i) =>
        Math.min(i + 1, filteredProducts.length - 1)
      );
    }

    if (e.key === "ArrowUp") {
      e.preventDefault();
      setSelectedIndex((i) =>
        Math.max(i - 1, 0)
      );
    }

    if (e.key === "Enter") {
      const p = filteredProducts[selectedIndex];
      if (!p) return;

      setActiveProduct(p);
      setActiveVariant(null);
      setVariantQty(1);
      setProductPickerOpen(false);
    }

  };

  window.addEventListener("keydown", handler);
  return () => window.removeEventListener("keydown", handler);

}, [productPickerOpen, filteredProducts, selectedIndex]);

  const ProductRow = ({ p }) => (
    <button
  type="button"
  onClick={() => {
    setProductPickerOpen(true);
    setProductSearch("");
    setProductSearchType("all");
  }}
      className="w-full flex items-center gap-3 px-3 py-3 hover:bg-[#f6f6f7] transition text-left"
    >
      <div className="w-10 h-10 rounded-lg overflow-hidden bg-[#f6f6f7] border border-[#e1e3e5] flex-shrink-0">
        {p.image ? (
          <img src={p.image} alt="" className="w-full h-full object-cover" />
        ) : null}
      </div>

      <div className="min-w-0">
        <div className="text-sm font-semibold text-[#202223] truncate">
          {lang === "EN" ? p.name_en : p.name_ar}
        </div>
        <div className="text-xs text-[#6d7175] truncate">{p.public_id}</div>
      </div>
    </button>
  );

  const CustomerRow = ({ c }) => (
  <button
    type="button"
    onClick={() => selectCustomer(c)}
    className="w-full flex items-start justify-between gap-3 px-4 py-3 hover:bg-[#f6f6f7] transition text-left"
  >

    <div className="min-w-0">

      <div className="text-sm font-semibold text-[#202223] truncate">
        {c.name}
      </div>

      <div className="text-xs text-[#6d7175] truncate">
        {[c.email, c.phone].filter(Boolean).join(" • ")}
      </div>

    </div>

  </button>
);

const isFormValid =
  items.length > 0 &&
  customer.name &&
  customer.phone &&
  !hasStockIssue;

  return (
    <div className="flex bg-[#f1f1f1] min-h-screen">
      <AdminSidebar isOpen={isOpen} setIsOpen={setIsOpen} />

      <div className={`flex-1 ${lang === "AR" ? "lg:mr-26" : "lg:ml-64"}`}>
        <AdminHeader
  setIsOpen={setIsOpen}
  customCenter={
    <div
      className={`
        hidden sm:block
        w-full
        sm:max-w-[500px]
        max-w-full
        transition-all duration-300
        ${isDirty ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-2 pointer-events-none"}
      `}
    >
      <div className="bg-[#2c2c2c] border border-[#3a3a3a] rounded-md px-3 py-2 sm:py-[4px] space-y-2 sm:space-y-0 sm:flex sm:items-center sm:justify-between">

        {/* LEFT */}
        <div className="flex items-center gap-2 text-[13px] text-gray-200 justify-between sm:justify-start">
          <FiAlertCircle className="text-white-400 text-[16px]" />
          <span>
            {lang === "AR" ? "طلب غير محفوظ" : "Unsaved order"}
          </span>
        </div>

        {/* RIGHT */}
        <div className="flex gap-2 sm:gap-1.5 w-full sm:w-auto">

          {/* DISCARD */}
          <button
            type="button"
            onClick={handleBackClick}
            className="
              px-2 py-[2px]
              text-[12px]
              rounded-md
              border border-[#3a3a3a]
              bg-[#1f1f1f]
              hover:bg-[#363636]
              text-gray-200
              transition
            "
          >
            {lang === "AR" ? "إلغاء" : "Discard"}
          </button>

          {/* SAVE */}
          <button
            type="button"
            onClick={() => setShowConfirm(true)}
            disabled={!isFormValid}
            className={`
              px-2 py-[2px]
              text-[12px]
              rounded-md
              font-medium
              transition
              ${
                isFormValid
                  ? "bg-white text-black hover:bg-gray-200"
                  : "bg-gray-400 text-gray-200 cursor-not-allowed"
              }
            `}
          >
            {lang === "AR" ? "حفظ" : "Save"}
          </button>

        </div>
      </div>
    </div>
  }
/>

        <main className="xl:p-3 sm:p-5 animate-fadeSlide">
          <div className="max-w-[1040px] mx-auto mx-1">
            {/* TOP BAR */}
            <div className="mx-3 mb-2 mt-5 flex items-center gap-2 text-sm">

  {/* ICON BUTTON */}
  <button
    onClick={() => handleNavigate("/admin/orders")}
    className="relative flex items-center justify-center w-8 h-8 rounded-md text-[#202223] hover:bg-gray-200 transition"
  >
    <FaInbox className="text-[16px] text-gray-900" />
  </button>

<FiChevronRight className="text-gray-400 text-[14px] shrink-0" />

  {/* CREATE ORDER */}
  <span className="font-semibold text-gray-900 text-[16px]">
    {TEXT.title}
  </span>

</div>

            {/* MAIN GRID */}
            <div className="grid grid-cols-1 xl:grid-cols-[minmax(0,1fr)_340px] gap-3">
              {/* LEFT COLUMN */}
              <div className="space-y-3 contents xl:block">
                {/* PRODUCTS */}
                <section className="order-3 xl:order-none bg-white border border-[#e1e3e5] rounded-none sm:rounded-[18px] shadow-sm overflow-visible">
                  <div className="p-4">
                    <h2 className="text-[15px] font-semibold text-[#202223] mb-4">
                      {TEXT.products}
                    </h2>

                    <div className="relative" ref={productPickerRef}>

  {/* MOBILE ADD PRODUCT BUTTON */}
  <button
    type="button"
    onClick={() => setProductPickerOpen(true)}
    className="sm:hidden w-full h-[42px] rounded-[12px] border border-[#c9cccf] bg-white text-[#202223] font-medium flex items-center justify-center gap-2 hover:bg-[#f1f2f3] transition"
  >
    {TEXT.addproducts}
  </button>

  {/* DESKTOP SEARCH + BROWSE */}
  <div className="hidden sm:flex flex-row gap-3">

    <button
      type="button"
      onClick={() => setProductPickerOpen(true)}
      className="flex-1 h-[42px] border border-[#8c9196] rounded-[12px] px-4 bg-white text-left text-[#6d7175] flex items-center gap-3 hover:border-[#616161] transition"
    >
      <FaSearch className="text-[#6d7175] text-sm" />
      <span>{TEXT.searchProducts}</span>
    </button>

    <button
      type="button"
      onClick={() => setProductPickerOpen(true)}
      className="h-[42px] px-5 rounded-[12px] border border-[#c9cccf] bg-white text-[#202223] font-medium hover:bg-[#f1f2f3] transition"
    >
      {TEXT.browse}
    </button>

  </div>

                      {productPickerOpen && (
  <div
  className="fixed inset-0 bg-black/60 backdrop-blur-[1px] z-50 flex items-center justify-center p-4"
  onClick={() => setProductPickerOpen(false)}
>
   <div
  onClick={(e) => e.stopPropagation()}
  className="w-full max-w-[640px] bg-white rounded-[18px] border border-[#e1e3e5] shadow-[0_20px_50px_rgba(0,0,0,0.25)] overflow-hidden"
>
      {/* HEADER */}
      <div className="bg-[#f6f6f7] px-6 py-4 border-b border-[#e1e3e5] flex items-center justify-between">
        <h3 className="text-[18px] font-semibold text-[#202223]">
           {TEXT.selectProducts}
        </h3>

        <button
          onClick={() => setProductPickerOpen(false)}
          className="w-8 h-8 rounded-full flex items-center justify-center text-[#6d7175] hover:bg-[#f1f2f3]"
        >
          <FaTimes />
        </button>
      </div>

      {/* SEARCH */}
      <div className="p-4 border-b border-[#e1e3e5]">
        <div className="flex flex-col sm:flex-row gap-2">

          <div className="flex-1 h-[42px] border border-[#8c9196] rounded-[12px] px-4 bg-white flex items-center gap-3">
            {productSearchLoading ? (
  <div className="w-4 h-4 border-2 border-[#6d7175] border-t-transparent rounded-full animate-spin" />
) : (
  <FaSearch className="text-[#6d7175] text-sm" />
)}
            <input
              autoFocus
              value={productSearch}
              onChange={(e) => {
  setProductSearch(e.target.value);
  setProductSearchLoading(true);
  setSelectedIndex(0);

  setTimeout(() => {
    setProductSearchLoading(false);
  }, 350);
}}
              placeholder={TEXT.searchProducts}
              className="flex-1 outline-none text-sm text-[#202223]"
            />
          </div>

          <select
            value={productSearchType}
            onChange={(e) => setProductSearchType(e.target.value)}
            className="h-[42px] w-full sm:w-[180px] rounded-[12px] border border-[#c9cccf] px-3 text-sm outline-none bg-white"
          >
            <option value="all">{TEXT.searchBy} {TEXT.all}</option>
            <option value="category"> {TEXT.category}</option>
            <option value="product_name"> {TEXT.productName}</option>
            <option value="product_id">{TEXT.productId}</option>
            <option value="color"> {TEXT.color}</option>
          </select>

        </div>
      </div>

      {/* TABLE HEADER */}
      <div className="grid grid-cols-[1fr_100px_120px] px-6 py-3 text-xs font-semibold text-[#6d7175] border-b border-[#e1e3e5] bg-[#f6f6f7]">
        <div>{TEXT.product}</div>
        <div>{TEXT.available}</div>
        <div>{TEXT.price}</div>
      </div>

      {/* TABLE BODY */}
     <div className="h-[320px] overflow-y-auto">

        {productsLoading ? (
  <ProductPickerSkeleton />
) : filteredProducts.length === 0 ? (
  <div className="p-6 text-sm text-[#6d7175]">
    {TEXT.noProducts}
  </div>
) : (
  filteredProducts.map((p, index) => {

            const available =
              p.variants?.reduce((sum, v) => sum + v.stock_qty, 0) || 0;

            const price = p.on_sale
              ? p.base_price * (1 - p.sale_percent / 100)
              : p.base_price;

            return (
              <button
                key={p.id}
                type="button"
                onClick={() => {
                  setActiveProduct(p);
                  setActiveVariant(null);
                  setVariantQty(1);
                  setProductPickerOpen(false);
                }}
                className={`w-full grid grid-cols-[1fr_100px_120px] items-center px-6 py-3 border-b border-[#f1f2f3] text-left
                  ${selectedIndex === index
                    ? "bg-[#f6f6f7]"
                    : "hover:bg-[#f6f6f7]"
                  }`}
              >

                {/* PRODUCT */}
                <div className="flex items-center gap-3">

                  <div className="w-10 h-10 rounded-lg overflow-hidden bg-[#f6f6f7] border border-[#e1e3e5] flex-shrink-0">
                    {p.image && (
                      <img
                        src={p.image}
                        alt=""
                        className="w-full h-full object-cover"
                      />
                    )}
                  </div>

                  <div className="min-w-0">
                    <div className="text-sm font-semibold text-[#202223] truncate">
                      {lang === "EN" ? p.name_en : p.name_ar}
                    </div>

                    <div className="text-xs text-[#6d7175]">
                      {p.public_id}
                    </div>
                  </div>

                </div>

                {/* AVAILABLE */}
                <div className="text-sm text-[#202223]">
                  {available}
                </div>

                {/* PRICE */}
                <div className="text-sm font-medium text-[#202223]">
                  ${Number(price).toFixed(2)}
                </div>

              </button>
            );
          })
        )}

      </div>

      {/* FOOTER */}
<div className="px-6 py-4 border-t border-[#e1e3e5] flex items-center justify-between">

  <div className="px-2 py-2 rounded-[10px] bg-[#f6f6f7] text-xs text-[#6d7175]">
    {productsLoading ? "..." : `${filteredProducts.length}/${products.length}`} {TEXT.productsCount}
  </div>

  <button
    onClick={() => setProductPickerOpen(false)}
    className="h-[36px] px-4 rounded-[10px] border border-[#c9cccf] bg-white text-[#202223] text-sm font-medium hover:bg-[#f1f2f3]"
  >
    {TEXT.cancel}
  </button>

</div> 
    </div>
  </div>
)}
                    </div>

{items.length === 0 && (
  <div className="mt-4 border border-dashed border-[#c9cccf] rounded-[14px] bg-[#fafafa] px-4 py-8 text-center">
    <FaInbox className="mx-auto text-[#8c9196] text-[22px] mb-2" />
    <p className="text-sm font-medium text-[#202223]">
      {TEXT.noProducts}
    </p>
    <p className="text-xs text-[#6d7175] mt-1">
      {TEXT.addProductFooter}
    </p>
  </div>
)}

                    {items.length > 0 && (
  <div className="mt-4 overflow-hidden">

    {/* HEADER */}
    <div className="hidden md:grid grid-cols-[1fr_160px_120px_120px_40px] bg-[#f6f6f7] text-xs font-semibold text-[#6d7175] px-4 py-2">
  <div>{TEXT.product}</div>
  <div className="text-center">{TEXT.colorSize}</div>
  <div className="text-center">{TEXT.quantity}</div>
  <div className="text-right">{TEXT.total}</div>
  <div></div>
</div>

    {/* ROWS */}
    {items.map((i, idx) => {

const product = products.find((p) => p.id === i.product_id);
const variant = product?.variants?.find((v) => v.id === i.variant_id);

const availableStock = variant?.stock_qty ?? 0;
const exceedsStock = i.quantity > availableStock;

const lineTotal = i.unit_price * i.quantity;

return (
  <React.Fragment key={`${i.product_id}-${i.variant_id}-${idx}`}>

    {exceedsStock && (
      <div className="px-4 py-2 bg-[#fff7e6] text-[#8a6116] text-sm border-b border-[#f1e3c2] flex items-center gap-2">
        ⚠️ {TEXT.stockWarning} {availableStock} {TEXT.unitsInStock}
      </div>
    )}

    <div className="hidden md:grid grid-cols-[1fr_160px_120px_120px_40px] items-center px-4 py-2 border-b border-[#f1f2f3] bg-white">

          {/* PRODUCT */}
          <div className="flex items-center gap-3 min-w-0">
            <div className="w-10 h-10 rounded-lg overflow-hidden bg-[#f6f6f7] border border-[#e1e3e5]">
              {product?.image && (
                <img
                  src={product.image}
                  alt=""
                  className="w-full h-full object-cover"
                />
              )}
            </div>

            <div className="min-w-0">
              <div className="text-sm font-semibold text-[#202223] truncate">
                {lang === "EN" ? i.name_en : i.name_ar}
              </div>

              <div className="text-xs text-[#6d7175]">
                ${Number(i.unit_price).toFixed(2)}
              </div>
            </div>
          </div>

          {/* SIZE / COLOR */}
          <div className="text-center text-sm text-[#6d7175]">
            {i.color} / {i.size}
          </div>

          {/* QUANTITY */}
          <div className="flex justify-center">
           <div
                className={`flex items-center rounded-md overflow-hidden h-[36px] border
                ${exceedsStock ? "border-red-400 bg-red-50" : "border-[#c9cccf]"}`}
              >

              <button
                onClick={() => updateItemQty(idx, i.quantity - 1)}
                disabled={i.quantity <= 1}
                className="w-[28px] h-full bg-[#f1f2f3] flex items-center justify-center text-sm hover:bg-[#e5e7eb]"
              >
                −
              </button>

              <input
              type="text"
              value={i.quantity}
              onChange={(e) => updateItemQty(idx, e.target.value)}
              className={`w-[40px] text-center text-sm outline-none
              ${exceedsStock ? "bg-red-50 text-red-700 font-semibold" : "bg-white"}`}
            />

            <button
              onClick={() => updateItemQty(idx, Number(i.quantity) + 1)}
              className="w-[28px] h-full bg-[#f1f2f3] flex items-center justify-center text-sm hover:bg-[#e5e7eb]"
            >
              +
            </button>

        </div>
          </div>

          {/* TOTAL */}
          <div className="text-right text-sm font-medium text-[#202223]">
            ${lineTotal.toFixed(2)}
          </div>

          {/* REMOVE */}
          <div className="flex justify-end">
            <button
              type="button"
              onClick={() => removeItem(idx)}
              className="w-7 h-7 rounded-full flex items-center justify-center text-[#6d7175] hover:bg-[#f1f2f3]"
            >
              <FaTimes />
            </button>
          </div>

        </div>

      {/* MOBILE ITEM CARD */}
<div className="md:hidden border-b border-[#f1f2f3] bg-white p-3 rounded-[12px] mb-2">

  <div className="flex items-center gap-3">

    <div className="w-12 h-12 rounded-lg overflow-hidden bg-[#f6f6f7] border border-[#e1e3e5]">
      {product?.image && (
        <img
          src={product.image}
          alt=""
          className="w-full h-full object-cover"
        />
      )}
    </div>

    <div className="flex-1 min-w-0">

      <div className="text-sm font-semibold text-[#202223] truncate">
        {lang === "EN" ? i.name_en : i.name_ar}
      </div>

      <div className="text-xs text-[#6d7175]">
        {i.color} / {i.size}
      </div>

      <div className="text-xs text-[#6d7175]">
        ${Number(i.unit_price).toFixed(2)}
      </div>

    </div>

    <button
      type="button"
      onClick={() => removeItem(idx)}
      className="w-8 h-8 rounded-full flex items-center justify-center text-[#6d7175] hover:bg-[#f1f2f3]"
    >
      <FaTimes />
    </button>

  </div>

  <div className="flex items-center justify-between mt-3">

    {/* QUANTITY */}
    <div
      className={`flex items-center rounded-md overflow-hidden h-[34px] border
      ${exceedsStock ? "border-red-400 bg-red-50" : "border-[#c9cccf]"}`}
    >

      <button
        onClick={() => updateItemQty(idx, i.quantity - 1)}
        disabled={i.quantity <= 1}
        className="w-[26px] h-full bg-[#f1f2f3] flex items-center justify-center"
      >
        −
      </button>

      <input
        type="text"
        value={i.quantity}
        onChange={(e) => updateItemQty(idx, e.target.value)}
        className="w-[36px] text-center text-sm outline-none"
      />

      <button
        onClick={() => updateItemQty(idx, Number(i.quantity) + 1)}
        className="w-[26px] h-full bg-[#f1f2f3] flex items-center justify-center"
      >
        +
      </button>

    </div>

    {/* LINE TOTAL */}
    <div className="text-sm font-semibold text-[#202223]">
      ${lineTotal.toFixed(2)}
    </div>

  </div>

</div>
  
    </React.Fragment>
      );
    })}
  </div>
)}
                  </div>
                </section>

                {/* PAYMENT */}
                <section className="order-4 xl:order-none bg-white border border-[#e1e3e5] rounded-none sm:rounded-[18px] shadow-sm overflow-hidden">
                  <div className="p-4">
                    <h2 className="text-[15px] font-semibold text-[#202223] mb-4">
                      {TEXT.payment}
                    </h2>

                    <div className="border border-[#e1e3e5] rounded-[14px] bg-[#fcfcfc] overflow-hidden">

                      <div className="text-[14px]">

                        {/* SUBTOTAL */}
                        <div className="grid grid-cols-[1fr_1fr_120px] items-center px-4 py-3">
                          <span className="text-[#202223] font-medium">{TEXT.subtotal}</span>
                          <span className="text-[#6d7175] text-center">{totalItems} {TEXT.items}</span>
                          <span className="text-right font-medium">${subtotal.toFixed(2)}</span>
                        </div>

                        {/* DISCOUNT */}
                        <div className="grid grid-cols-[1fr_1fr_120px] items-center px-4 py-3">

                          <button
                            onClick={() => setDiscountModalOpen(true)}
                            className="text-[#1a73e8] font-medium text-left hover:underline"
                          >
                            {discountValue > 0 ? TEXT.editDiscount : TEXT.addDiscount}
                          </button>

                          <span className="text-center text-[#6d7175]">
                            {discountValue > 0
  ? discountType === "percent"
    ? `${discountAmount}%`
    : `$${discountAmount}`
  : "—"}
                          </span>

                          <span className="text-right text-[#202223]">
                            {discountValue > 0 ? `− $${discountValue.toFixed(2)}` : "$0.00"}
                          </span>

                        </div>

                        {/* SHIPPING */}
                        <div className="grid grid-cols-[1fr_1fr_120px] items-center px-4 py-3">

                          <button
                            onClick={() => setShippingModalOpen(true)}
                            className="text-[#1a73e8] font-medium text-left hover:underline"
                          >
                            {TEXT.shipping}
                          </button>

                          <span className="text-center text-[#6d7175]">
                            {order.shipping_method === "pickup"
                              ? TEXT.pickup
                              : TEXT.delivery}
                          </span>

                          <span className="text-right text-[#202223]">
                            ${shippingFee.toFixed(2)}
                          </span>

                        </div>

                        {/* EXTRA FEES */}
                        <div className="grid grid-cols-[1fr_1fr_120px] items-center px-4 py-3">

                          <button
                            onClick={() => setExtraFeesModalOpen(true)}
                            className="text-[#1a73e8] font-medium text-left hover:underline"
                          >
                            {TEXT.extraFees}
                          </button>

                          <span className="text-center text-[#6d7175]">
                            {order.extra_fee_label || "—"}
                          </span>

                          <span className="text-right text-[#202223]">
                            {extraFeeAmount > 0 ? `$${extraFeeAmount.toFixed(2)}` : "$0.00"}
                          </span>

                        </div>

                        {/* TOTAL */}
                        <div className="grid grid-cols-[1fr_120px_120px] items-center px-4 py-4 font-semibold text-[15px]">

                          <span>{TEXT.total}</span>
                          <span></span>
                          <span className="text-right">${total.toFixed(2)}</span>

                        </div>

                      </div>

                    </div>
                  </div>

                  <div className="px-5 py-4 bg-[#f6f6f7] border-t border-[#e1e3e5]">
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                      <p className="text-sm text-[#4a4a4a]">
                        {TEXT.addProductFooter}
                      </p>

                      <div className="flex flex-wrap gap-3">
                        <button
                          onClick={() => handleNavigate("/admin/orders")}
                          className="h-[40px] px-5 rounded-[10px] border border-[#c9cccf] bg-white text-[#202223] font-medium hover:bg-[#f1f2f3] transition"
                        >
                          {TEXT.cancel}
                        </button>

                        <button
  onClick={() => setShowConfirm(true)}
  disabled={isOrderInvalid || creatingOrder}
  className={`h-[40px] px-5 rounded-[10px] font-medium transition
  ${
  isOrderInvalid
    ? "bg-gray-300 text-gray-500 cursor-not-allowed"
    : "bg-[#202223] text-white hover:bg-black"
}`}
>
  {creatingOrder ? "..." : TEXT.createOrder}
</button>
                      </div>
                    </div>
                  </div>
                </section>
              </div>

              {/* RIGHT COLUMN */}
              <div className="space-y-3 contents xl:block">
                {/* NOTES */}
                <section className="order-5 xl:order-none mb-4 xl:mb-0 bg-white border border-[#e1e3e5] rounded-none sm:rounded-[18px] shadow-sm">
                  <div className="p-4">
                    <div className="flex items-start justify-between gap-3">
                      <div>
                        <h2 className="text-[15px] font-semibold text-[#202223]">
                          {TEXT.notes}
                        </h2>
                        <p className="text-[15px] text-[#6d7175] mt-2 whitespace-pre-wrap">
                          {order.notes?.trim() ? order.notes : TEXT.noNotes}
                        </p>
                      </div>

                      <button
                        type="button"
                        onClick={() => {
                          setDraftNote(order.notes || "");
                          setNoteOpen(true);
                        }}
                        className="w-8 h-8 rounded-full flex items-center justify-center text-[#6d7175] hover:bg-[#f1f2f3] transition"
                      >
                        <FaPen />
                      </button>
                    </div>
                  </div>
                </section>

                {/* CUSTOMER */}
                <section className="order-1 xl:order-none bg-white border border-[#e1e3e5] rounded-none sm:rounded-[18px] shadow-sm overflow-visible">
                  <div className="p-5" ref={customerPickerRef}>
                    <h2 className="text-[15px] font-semibold text-[#202223] mb-4">
                      {TEXT.customer}
                    </h2>

                    <button
                      type="button"
                      onClick={() => setCustomerPickerOpen(true)}
                      className="w-full h-[42px] border border-[#8c9196] rounded-[12px] px-4 bg-white text-left text-[#6d7175] flex items-center gap-3 hover:border-[#616161] transition"
                    >
                      <FaSearch className="text-[#6d7175] text-sm" />
                      <span>
                        {customer.name?.trim() ? customer.name : TEXT.searchCustomer}
                      </span>
                    </button>

                    {customerPickerOpen && (
  <div className="relative mt-2">

    <div className="absolute left-0 right-0 bg-white border border-[#e1e3e5] rounded-[16px] shadow-[0_12px_28px_rgba(0,0,0,0.12)] z-40 overflow-hidden">

      {/* SEARCH INPUT */}
      <div className="p-3 border-b border-[#e1e3e5]">

        <div className="h-[42px] border border-[#8c9196] rounded-[12px] px-4 bg-white flex items-center gap-3">

          <FaSearch className="text-[#6d7175] text-sm" />

          <input
            autoFocus
            value={customerSearch}
            onChange={(e) => setCustomerSearch(e.target.value)}
            placeholder={TEXT.searchOrCreateCustomer}
            className="flex-1 outline-none text-sm text-[#202223]"
          />

        </div>

      </div>

      {/* CREATE CUSTOMER */}
      <button
        type="button"
        onClick={() => {
          setCreateCustomerOpen(true);
          setCustomerPickerOpen(false);
        }}
        className="w-full flex items-center gap-3 px-4 py-3 border-b border-[#f1f2f3] text-left hover:bg-[#f6f6f7]"
      >
        <div className="w-7 h-7 rounded-full bg-[#f1f2f3] flex items-center justify-center text-[#6d7175]">
          <FaPlus size={12} />
        </div>

        <span className="text-sm text-[#202223] font-medium">
          {TEXT.createCustomer}
        </span>
      </button>

      {/* CUSTOMER LIST */}
      <div className="max-h-[320px] overflow-y-auto">

       {customersLoading ? (
  <CustomerPickerSkeleton />
) : filteredCustomers.length === 0 ? (
  <div className="px-4 py-5 text-sm text-[#6d7175]">
    {TEXT.noCustomers}
  </div>
) : (
  filteredCustomers.map((c) => (
    <CustomerRow key={c.id} c={c} />
  ))
)}

      </div>

    </div>

  </div>
)}

    {customerDetailsLoading ? (
  <div className="mt-4 border border-[#e1e3e5] rounded-[14px] bg-white p-4 space-y-4">
    <SkeletonLine className="h-4 w-32" />
    <SkeletonLine className="h-3 w-48" />
    <SkeletonLine className="h-3 w-28" />
    <div className="pt-3 space-y-2">
      <SkeletonLine className="h-3 w-36" />
      <SkeletonLine className="h-3 w-44" />
      <SkeletonLine className="h-3 w-40" />
    </div>
  </div>
) : customer.name && (
  <div className="mt-4 border border-[#e1e3e5] rounded-[14px] bg-white relative">
    {/* HEADER */}
    <div className="flex items-start justify-between px-4 pt-4">

      <div>
        <div className="text-[14px] font-semibold text-[#202223]">
          {TEXT.customer}
        </div>

        <div className="text-[14px] text-[#1a73e8] font-medium">
          {customer.name}
        </div>

        <div className="text-sm text-[#6d7175]">
  {customerOrdersCount === 0
  ? TEXT.noOrders
  : `${customerOrdersCount} ${
      customerOrdersCount > 1 ? TEXT.orderCountPlural : TEXT.orderCount
    }`}
</div>
      </div>

      {/* 3 DOT MENU */}
      <button
        onClick={() => setCustomerMenuOpen(!customerMenuOpen)}
        className="w-8 h-8 rounded-md flex items-center justify-center hover:bg-[#f1f2f3]"
      >
        ⋯
      </button>

      {customerMenuOpen && (
  <div
    ref={customerMenuRef}
    className="absolute right-3 top-12 w-[220px] bg-white border border-[#e1e3e5] rounded-[12px] shadow-md overflow-hidden z-20"
  >

          <button
            onClick={() => {
              setEditAddressOpen(true);
              setCustomerMenuOpen(false);
            }}
            className="w-full text-left px-4 py-3 text-sm hover:bg-[#f6f6f7]"
          >
            {TEXT.editShippingAddress}
          </button>

          <button
            onClick={() => {
              setCustomer({
  name: "",
  phone: "",
  email: "",
  country: "Lebanon",
  governorate: "",
  area: "",
  street: "",
  building: "",
  note: "",
});
              setCustomerMenuOpen(false);
            }}
            className="w-full text-left px-4 py-3 text-sm text-red-600 hover:bg-[#f6f6f7]"
          >
            {TEXT.removeCustomer}
          </button>

        </div>
      )}

    </div>

    {/* CONTACT */}
    <div className="px-4 pt-4">

      <div className="text-xs text-[#6d7175] font-semibold mb-1">
        {TEXT.contactInformation}
      </div>

      {customer.email && (
        <div className="text-sm text-[#1a73e8]">
          {customer.email}
        </div>
      )}

      <div className="text-sm text-[#202223]">
        {customer.phone}
      </div>

    </div>

    {/* SHIPPING */}
    <div className="px-4 py-4">

      <div className="text-xs text-[#6d7175] font-semibold mb-1">
        {TEXT.shippingAddress}
      </div>

      <div className="text-sm text-[#202223] leading-relaxed">
        {customer.name}
        <br />
        {customer.area}
        <br />
        {customer.street}
        <br />
        {customer.governorate}
        <br />
        {customer.phone}
      </div>
    </div>

  </div>
)}
                  </div>
                </section>
                {/* ORDER SETTINGS */}
<section className="order-2 xl:order-none bg-white border border-[#e1e3e5] rounded-none sm:rounded-[18px] shadow-sm">
  <div className="p-4">
    <div className="grid grid-cols-1 gap-3">
      <div className="border border-[#e1e3e5] rounded-[14px] p-4">
        <label className="block text-xs font-semibold text-[#6d7175] mb-2">
          {TEXT.source}
        </label>
        <select
          className="w-full h-[40px] rounded-[10px] border border-[#c9cccf] px-3 text-sm outline-none"
          value={order.order_source}
          onChange={(e) =>
            setOrder({ ...order, order_source: e.target.value })
          }
        >
          <option value="website">{TEXT.website}</option>
          <option value="whatsapp">{TEXT.whatsapp}</option>
          <option value="store">{TEXT.store}</option>
        </select>
      </div>

      <div className="border border-[#e1e3e5] rounded-[14px] p-4">
        <label className="block text-xs font-semibold text-[#6d7175] mb-2">
          {TEXT.shippingMethod}
        </label>
        <select
          className="w-full h-[40px] rounded-[10px] border border-[#c9cccf] px-3 text-sm outline-none"
          value={order.shipping_method}
          onChange={(e) =>
            setOrder((prev) => ({
              ...prev,
              shipping_method: e.target.value,
              shipping_fee:
                e.target.value === "pickup"
                  ? 0
                  : Number(prev.shipping_fee || 4),
            }))
          }
        >
          <option value="delivery">{TEXT.delivery}</option>
          <option value="pickup">{TEXT.pickup}</option>
        </select>
      </div>
    </div>
  </div>
</section>
              </div>
            </div>
          </div>

          {/* PRODUCT VARIANT MODAL */}
          {activeProduct && (
            <div className="fixed inset-0 bg-black/60 backdrop-blur-[1px] z-50 flex items-center justify-center p-4">
              <div className="w-full max-w-[420px] bg-white rounded-[18px] border border-[#e1e3e5] shadow-xl overflow-hidden">
                <div className="px-5 py-4 border-b border-[#e1e3e5]">
                  <h3 className="text-lg font-semibold text-[#202223]">
                    {lang === "EN" ? activeProduct.name_en : activeProduct.name_ar}
                  </h3>
                </div>

                <div className="p-5 max-h-[60vh] overflow-y-auto">
                  {availableVariants.length === 0 && (
                    <p className="text-sm text-[#6d7175]">{TEXT.noVariants}</p>
                  )}

                  <div className="space-y-2">
                    {availableVariants.map((v) => (
                      <button
                        key={v.id}
                        type="button"
                        onClick={() => {
                          setActiveVariant(v);
                          setVariantQty(1);
                        }}
                        className={`w-full border rounded-[12px] px-4 py-3 text-left transition ${
                          activeVariant?.id === v.id
                            ? "border-[#008060] bg-[#eef7f3]"
                            : "border-[#e1e3e5] hover:bg-[#f6f6f7]"
                        }`}
                      >
                        <div className="flex items-center justify-between gap-3">
                          <div className="text-sm font-medium text-[#202223]">
                            {v.color_name} / {v.size}
                          </div>
                          <div className="text-xs text-[#6d7175]">
                            {TEXT.stock}: {v.stock_qty}
                          </div>
                        </div>
                      </button>
                    ))}
                  </div>

                  {activeVariant && (
                    <div className="mt-4 border border-[#e1e3e5] rounded-[14px] p-4">
                      <div className="text-xs font-semibold text-[#6d7175] mb-2">
                        {TEXT.quantity}
                      </div>

                      <div className="flex items-center justify-center gap-4">
                        <button
                          disabled={variantQty <= 1}
                          onClick={() => setVariantQty((q) => q - 1)}
                          className="w-10 h-10 rounded-full bg-[#f1f2f3] disabled:opacity-40"
                        >
                          −
                        </button>

                        <span className="text-lg font-semibold text-[#202223]">
                          {variantQty}
                        </span>

                        <button
                          disabled={variantQty >= activeVariant.stock_qty}
                          onClick={() => setVariantQty((q) => q + 1)}
                          className="w-10 h-10 rounded-full bg-[#f1f2f3] disabled:opacity-40"
                        >
                          +
                        </button>
                      </div>
                    </div>
                  )}
                </div>

                <div className="px-5 py-4 border-t border-[#e1e3e5] flex justify-end gap-3">
                  <button
                    onClick={() => setActiveProduct(null)}
                    className="h-[40px] px-5 rounded-[10px] border border-[#c9cccf] bg-white text-[#202223] font-medium hover:bg-[#f1f2f3] transition"
                  >
                    {TEXT.cancel}
                  </button>

                  <button
                    onClick={confirmAddItem}
                    disabled={!activeVariant}
                    className="h-[40px] px-5 rounded-[10px] bg-[#202223] text-white font-medium disabled:opacity-50"
                  >
                    {TEXT.ok}
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* NOTE MODAL */}
{noteOpen && (
  <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4">

    <div className="w-full max-w-[640px] bg-white rounded-[14px] border border-[#e1e3e5] shadow-[0_20px_60px_rgba(0,0,0,0.25)] overflow-hidden">

      {/* HEADER */}
      <div className="flex items-center justify-between px-6 py-3 border-b border-[#e1e3e5]  bg-[#f6f6f7]">
        <h3 className="text-[16px] font-semibold text-[#202223]">
          {TEXT.addNote}
        </h3>

        <button
          onClick={() => setNoteOpen(false)}
          className="w-8 h-8 flex items-center justify-center rounded-md text-[#6d7175] hover:bg-[#f1f2f3]"
        >
          <FaTimes />
        </button>
      </div>

      {/* BODY */}
      <div className="px-6 py-4">

        <div className="relative">

          <textarea
            value={draftNote}
            onChange={(e) => setDraftNote(e.target.value)}
            maxLength={5000}
            className="w-full h-[80px] border border-[#c9cccf] rounded-[10px] px-4 py-2 text-[14px] text-[#202223] outline-none resize-none focus:border-[#008060]"
          />

          <div className="absolute bottom-2 right-3 text-[12px] text-[#6d7175]">
            {draftNote.length}/5000
          </div>

        </div>

        <p className="text-[12px] text-[#8c9196] mt-1">
          {TEXT.noteHelper}
        </p>

      </div>

      {/* FOOTER */}
      <div className="flex justify-end gap-3 px-6 py-4 border-t border-[#e1e3e5]">

        <button
          onClick={() => setNoteOpen(false)}
          className="h-[36px] px-4 rounded-[8px] border border-[#c9cccf] bg-white text-[14px] text-[#202223] font-medium hover:bg-[#f1f2f3]"
        >
          {TEXT.cancel}
        </button>

        <button
          onClick={saveNote}
          className={`h-[36px] px-4 rounded-[8px] text-[14px] font-semibold transition
          ${
            draftNote.trim().length === 0
              ? "bg-[#e1e3e5] text-[#8c9196] cursor-not-allowed"
              : "bg-[#202223] text-white hover:bg-black"
          }`}
          disabled={!draftNote.trim()}
        >
          {TEXT.done}
        </button>

      </div>

    </div>

  </div>
)}

          {/* CREATE CUSTOMER MODAL */}
          {createCustomerOpen && (
            <div className="fixed inset-0 bg-black/60 backdrop-blur-[1px] z-50 flex items-center justify-center p-4">
              <div className="w-full max-w-[720px] bg-white rounded-[18px] border border-[#e1e3e5] shadow-xl overflow-hidden">
                <div className="px-5 py-4 border-b border-[#e1e3e5]">
                  <h3 className="text-lg font-semibold text-[#202223]">
                    {TEXT.createCustomerTitle}
                  </h3>
                </div>

                <div className="p-5 grid md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-xs font-semibold text-[#6d7175] mb-2">
                      {TEXT.name}
                    </label>
                    <input
                      className="w-full h-[42px] rounded-[12px] border border-[#c9cccf] px-3 text-sm outline-none"
                      value={newCustomer.name}
                      onChange={(e) =>
                        setNewCustomer({ ...newCustomer, name: e.target.value })
                      }
                    />
                  </div>

                  <div>
                    <label className="block text-xs font-semibold text-[#6d7175] mb-2">
                      {TEXT.phone}
                    </label>
                    <input
                      className="w-full h-[42px] rounded-[12px] border border-[#c9cccf] px-3 text-sm outline-none"
                      value={newCustomer.phone}
                      onChange={(e) =>
                        setNewCustomer({
                          ...newCustomer,
                          phone: formatPhone(e.target.value),
                        })
                      }
                    />
                  </div>

                  <div>
                    <label className="block text-xs font-semibold text-[#6d7175] mb-2">
                      {TEXT.email}
                    </label>
                    <input
                      className="w-full h-[42px] rounded-[12px] border border-[#c9cccf] px-3 text-sm outline-none"
                      value={newCustomer.email}
                      onChange={(e) =>
                        setNewCustomer({ ...newCustomer, email: e.target.value })
                      }
                    />
                  </div>
<div>
  <label className="block text-xs font-semibold text-[#6d7175] mb-2">
    {TEXT.country}
  </label>

  <select
    className="w-full h-[42px] rounded-[12px] border border-[#c9cccf] px-3 text-sm outline-none bg-white"
    value={newCustomer.country}
    onChange={(e) =>
      setNewCustomer({
        ...newCustomer,
        country: e.target.value,
        governorate: "",
      })
    }
  >
    <option value="Lebanon">{lang === "AR" ? "لبنان" : "Lebanon"}</option>
    <option value="Syria">{lang === "AR" ? "سوريا" : "Syria"}</option>
  </select>
</div>
{newCustomer.country === "Lebanon" ? (
  <select
    className="w-full h-[42px] rounded-[12px] border border-[#c9cccf] px-3 text-sm outline-none bg-white"
    value={newCustomer.governorate}
    onChange={(e) =>
      setNewCustomer({ ...newCustomer, governorate: e.target.value })
    }
  >
    <option value="">{TEXT.selectGovernorate}</option>
    {LEBANON_GOVERNORATES.map((g) => (
      <option key={g.EN} value={g.EN}>
        {lang === "EN" ? g.EN : g.AR}
      </option>
    ))}
  </select>
) : (
  <input
    className="w-full h-[42px] rounded-[12px] border border-[#c9cccf] px-3 text-sm outline-none"
    value={newCustomer.governorate}
    onChange={(e) =>
      setNewCustomer({ ...newCustomer, governorate: e.target.value })
    }
    placeholder={lang === "AR" ? "اكتب المحافظة" : "Enter governorate"}
  />
)}

                  <div>
                    <label className="block text-xs font-semibold text-[#6d7175] mb-2">
                      {TEXT.area}
                    </label>
                    <input
                      className="w-full h-[42px] rounded-[12px] border border-[#c9cccf] px-3 text-sm outline-none"
                      value={newCustomer.area}
                      onChange={(e) =>
                        setNewCustomer({ ...newCustomer, area: e.target.value })
                      }
                    />
                  </div>

                  <div>
                    <label className="block text-xs font-semibold text-[#6d7175] mb-2">
                      {TEXT.street}
                    </label>
                    <input
                      className="w-full h-[42px] rounded-[12px] border border-[#c9cccf] px-3 text-sm outline-none"
                      value={newCustomer.street}
                      onChange={(e) =>
                        setNewCustomer({ ...newCustomer, street: e.target.value })
                      }
                    />
                  </div>

                  <div>
                    <label className="block text-xs font-semibold text-[#6d7175] mb-2">
                      {TEXT.building}
                    </label>
                    <input
                      className="w-full h-[42px] rounded-[12px] border border-[#c9cccf] px-3 text-sm outline-none"
                      value={newCustomer.building}
                      onChange={(e) =>
                        setNewCustomer({
                          ...newCustomer,
                          building: e.target.value,
                        })
                      }
                    />
                  </div>

                  <div>
                    <label className="block text-xs font-semibold text-[#6d7175] mb-2">
                      {TEXT.note}
                    </label>
                    <input
                      className="w-full h-[42px] rounded-[12px] border border-[#c9cccf] px-3 text-sm outline-none"
                      value={newCustomer.note}
                      onChange={(e) =>
                        setNewCustomer({ ...newCustomer, note: e.target.value })
                      }
                    />
                  </div>
                </div>

                <div className="px-5 py-4 border-t border-[#e1e3e5] flex justify-end gap-3">
                  <button
                    onClick={() => setCreateCustomerOpen(false)}
                    className="h-[40px] px-5 rounded-[10px] border border-[#c9cccf] bg-white text-[#202223] font-medium hover:bg-[#f1f2f3] transition"
                  >
                    {TEXT.cancel}
                  </button>

                  <button
  onClick={createCustomerLocally}
  disabled={creatingCustomer}
  className="h-[40px] px-5 rounded-[10px] bg-[#202223] text-white font-medium disabled:opacity-50"
>
  {creatingCustomer ? "..." : TEXT.createCustomer}
</button>
                </div>
              </div>
            </div>
          )}

{editAddressOpen && (
  <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">

    <div className="w-full max-w-[520px] bg-white rounded-[18px] border border-[#e1e3e5] shadow-xl">

      <div className="px-6 py-4 border-b border-[#e1e3e5]">
        <h3 className="text-lg font-semibold text-[#202223]">
          {TEXT.editShippingAddress}
        </h3>
      </div>

      <div className="p-6 grid gap-4">

  <div>
    <label className="text-xs text-[#6d7175] mb-1 block">{TEXT.city}</label>
    <input
      value={customer.governorate}
      onChange={(e)=>setCustomer({...customer, governorate:e.target.value})}
      className="w-full h-[42px] border border-[#c9cccf] rounded-[10px] px-3"
    />
  </div>

  <div>
    <label className="text-xs text-[#6d7175] mb-1 block">{TEXT.area}</label>
    <input
      value={customer.area}
      onChange={(e)=>setCustomer({...customer, area:e.target.value})}
      className="w-full h-[42px] border border-[#c9cccf] rounded-[10px] px-3"
    />
  </div>

  <div>
    <label className="text-xs text-[#6d7175] mb-1 block">{TEXT.street}</label>
    <input
      value={customer.street}
      onChange={(e)=>setCustomer({...customer, street:e.target.value})}
      className="w-full h-[42px] border border-[#c9cccf] rounded-[10px] px-3"
    />
  </div>

  <div>
    <label className="text-xs text-[#6d7175] mb-1 block">{TEXT.building}</label>
    <input
      value={customer.building}
      onChange={(e)=>setCustomer({...customer, building:e.target.value})}
      className="w-full h-[42px] border border-[#c9cccf] rounded-[10px] px-3"
    />
  </div>

</div>

      <div className="px-6 py-4 border-t border-[#e1e3e5] flex justify-end gap-3">

        <button
          onClick={()=>setEditAddressOpen(false)}
          className="h-[38px] px-4 border border-[#c9cccf] rounded-[10px]"
        >
          {TEXT.cancel}
        </button>

        <button
  onClick={saveEditedAddress}
  disabled={savingAddress}
  className="h-[38px] px-4 bg-[#202223] text-white rounded-[10px] hover:bg-black transition disabled:opacity-50"
>
  {savingAddress ? "..." : TEXT.save}
</button>

      </div>

    </div>

  </div>
)}

{discountModalOpen && (
<div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">

  <div className="bg-white rounded-[18px] border border-[#e1e3e5] w-full max-w-[420px] overflow-hidden">

    <div className="px-6 py-3 border-b border-[#e1e3e5] bg-[#f6f6f7]">
      <h3 className="text-lg font-semibold text-[#202223]">{TEXT.discountTitle}</h3>
    </div>

    <div className="p-5 space-y-4">

      {/* TYPE */}
      <div>
        <label className="text-xs font-semibold text-[#6d7175] block mb-2">
          {TEXT.discountType}
        </label>

        <select
          value={discountType}
          onChange={(e)=>setDiscountType(e.target.value)}
          className="w-full h-[42px] border border-[#c9cccf] rounded-[10px] px-3 text-sm outline-none"
        >
          <option value="percent">{TEXT.percentage}</option>
          <option value="fixed">{TEXT.fixedAmount}</option>
        </select>
      </div>

      {/* AMOUNT */}
      <div>
        <label className="text-xs font-semibold text-[#6d7175] block mb-2">
          {TEXT.amount}
        </label>

        <input
          type="number"
          min="0"
          value={order.discount_amount}
          onChange={(e)=>
            setOrder({...order, discount_amount:Number(e.target.value)})
          }
          className="w-full h-[42px] border border-[#c9cccf] rounded-[10px] px-3 text-sm outline-none"
          placeholder={discountType === "percent" ? "10%" : "$10"}
        />
      </div>

    </div>

    <div className="px-6 py-3 border-t border-[#e1e3e5] flex justify-end gap-3 bg-[#f6f6f7]">

      <button
        onClick={()=>setDiscountModalOpen(false)}
        className="h-[38px] px-4 border border-[#c9cccf] rounded-[10px]"
      >
        {TEXT.cancel}
      </button>

      <button
        onClick={()=>setDiscountModalOpen(false)}
        className="h-[38px] px-4 bg-[#202223] text-white rounded-[10px] hover:bg-black transition"
      >
        {TEXT.save}
      </button>

    </div>

  </div>

</div>
)}

{shippingModalOpen && (
<div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">

  <div className="bg-white rounded-[18px] border border-[#e1e3e5] w-full max-w-[420px] overflow-hidden">

    <div className="px-6 py-3 border-b border-[#e1e3e5] bg-[#f6f6f7]">
      <h3 className="text-lg font-semibold text-[#202223]">{TEXT.shippingFeeTitle}</h3>
    </div>

    <div className="p-5">

      <label className="text-xs font-semibold text-[#6d7175] block mb-2">
        {TEXT.deliveryFee}
      </label>

      <input
        type="number"
        min="0"
        step="0.01"
        value={order.shipping_fee}
        onChange={(e)=>
          setOrder({...order, shipping_fee:Number(e.target.value)})
        }
        className="w-full h-[42px] border border-[#c9cccf] rounded-[10px] px-3 text-sm outline-none"
      />

    </div>

    <div className="px-6 py-3 bg-[#f6f6f7] border-t border-[#e1e3e5] flex justify-end gap-3">

      <button
        onClick={()=>setShippingModalOpen(false)}
        className="h-[38px] px-4 border border-[#c9cccf] rounded-[10px]"
      >
        {TEXT.cancel}
      </button>

      <button
        onClick={()=>setShippingModalOpen(false)}
        className="h-[38px] px-4 bg-[#202223] text-white rounded-[10px] hover:bg-black transition"
      >
        {TEXT.save}
      </button>

    </div>

  </div>

</div>
)}

{extraFeesModalOpen && (
<div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">

  <div className="bg-white rounded-[18px] border border-[#e1e3e5] w-full max-w-[420px] overflow-hidden">

    <div className="px-6 py-3 border-b border-[#e1e3e5] bg-[#f6f6f7]">
      <h3 className="text-lg font-semibold text-[#202223]">{TEXT.extraFeesTitle}</h3>
    </div>

    <div className="p-5 space-y-4">

      {/* LABEL */}
      <div>
        <label className="text-xs font-semibold text-[#6d7175] block mb-2">
          {TEXT.label}
        </label>

        <input
          type="text"
          value={order.extra_fee_label}
          onChange={(e)=>
            setOrder({...order, extra_fee_label:e.target.value})
          }
          className="w-full h-[42px] border border-[#c9cccf] rounded-[10px] px-3 text-sm outline-none"
          placeholder={TEXT.exampleInsurance}
        />
      </div>

      {/* AMOUNT */}
      <div>
        <label className="text-xs font-semibold text-[#6d7175] block mb-2">
          {TEXT.amount}
        </label>

        <input
          type="number"
          min="0"
          step="0.01"
          value={order.extra_fee_amount}
          onChange={(e)=>
            setOrder({...order, extra_fee_amount:Number(e.target.value)})
          }
          className="w-full h-[42px] border border-[#c9cccf] rounded-[10px] px-3 text-sm outline-none"
        />
      </div>

    </div>

    <div className="px-6 py-3 border-t border-[#e1e3e5] flex justify-end gap-3 bg-[#f6f6f7]">

      <button
        onClick={()=>setExtraFeesModalOpen(false)}
        className="h-[38px] px-4 border border-[#c9cccf] rounded-[10px]"
      >
        {TEXT.cancel}
      </button>

      <button
        onClick={()=>setExtraFeesModalOpen(false)}
       className="h-[38px] px-4 bg-[#202223] text-white rounded-[10px] hover:bg-black transition"
      >
        {TEXT.save}
      </button>

    </div>

  </div>

</div>
)}

{showLeaveConfirm && (
  <div className="fixed inset-0 bg-black/60 backdrop-blur-[1px] z-50 flex items-center justify-center p-4">
    <div className="w-full max-w-[420px] bg-white rounded-[18px] border border-[#e1e3e5] shadow-xl overflow-hidden">

      {/* HEADER */}
      <div className="px-5 py-4 border-b border-[#e1e3e5]">
        <h3 className="text-lg font-semibold text-[#202223]">
          {lang === "EN" ? "Leave page?" : "مغادرة الصفحة؟"}
        </h3>
      </div>

      {/* BODY */}
      <div className="p-5 text-sm text-[#202223]">
        {lang === "EN"
          ? "You have unsaved changes. If you leave, they will be lost."
          : "لديك تغييرات غير محفوظة. إذا غادرت، سيتم فقدانها."}
      </div>

      {/* FOOTER */}
      <div className="px-5 py-4 border-t border-[#e1e3e5] flex justify-end gap-3">

        <button
          onClick={() => setShowLeaveConfirm(false)}
          className="h-[40px] px-5 rounded-[10px] border border-[#c9cccf] bg-white text-[#202223] font-medium hover:bg-[#f1f2f3]"
        >
          {TEXT.cancel}
        </button>

        <button
          onClick={() => {
            setShowLeaveConfirm(false);
            pendingNavigation && pendingNavigation();
          }}
          className="h-[40px] px-5 rounded-[10px] bg-[#202223] text-white font-medium"
        >
          {lang === "EN" ? "Leave" : "مغادرة"}
        </button>

      </div>

    </div>
  </div>
)}

          {/* CONFIRM MODAL */}
          {showConfirm && (
            <div className="fixed inset-0 bg-black/60 backdrop-blur-[1px] z-50 flex items-center justify-center p-4">
              <div className="w-full max-w-[420px] bg-white rounded-[18px] border border-[#e1e3e5] shadow-xl overflow-hidden">
                <div className="px-5 py-4 border-b border-[#e1e3e5]">
                  <h3 className="text-lg font-semibold text-[#202223]">
                    {TEXT.confirmOrder}
                  </h3>
                </div>

                <div className="p-5 space-y-2 text-sm text-[#202223]">
                  <p><b>{customer.name}</b></p>
                  <p>{customer.phone}</p>
                  <p>{items.length} {TEXT.itemCount}</p>
                  <p className="font-semibold">${total.toFixed(2)}</p>
                </div>

               <div className="px-5 py-4 border-t border-[#e1e3e5] flex justify-end gap-3">
                  <button
                    onClick={() => setShowConfirm(false)}
                    className="h-[40px] px-5 rounded-[10px] border border-[#c9cccf] bg-white text-[#202223] font-medium hover:bg-[#f1f2f3] transition"
                  >
                    {TEXT.cancel}
                  </button>

                  <button
  onClick={submit}
  disabled={creatingOrder}
  className="h-[40px] px-5 rounded-[10px] bg-[#202223] text-white font-medium disabled:opacity-50"
>
  {creatingOrder ? "..." : TEXT.confirm}
</button>
                </div>
              </div>
            </div>
          )}
        </main>
      </div>
    </div>
  );
}

export default AdminAddOrders;
